import { FC } from 'react'
import cx from 'classnames'
import { useTheme } from 'styled-components'

import { AvatarProps } from '../Avatar'
import { ActionButtonProps } from '../ActionButton'
import { LinkProps } from '../Link'
import { Icons } from '../Icon'

import * as SC from './styled'

export type AdsAuthorCardProps = {
  className?: string
  avatar: AvatarProps
  description?: string
  button?: ActionButtonProps
  addressLabel: string
  address: string
  links: {
    seeItinerary?: LinkProps
    discoverAds?: LinkProps
  }
  adsNumber: string
}

const AdsAuthorCard: FC<AdsAuthorCardProps> = ({
  className,
  avatar,
  description,
  button,
  addressLabel,
  address,
  links,
  adsNumber,
}) => {
  const theme = useTheme()
  return (
    <SC.AdsAuthorCard className={cx('AdsAuthorCard', className)}>
      <SC.AuthorAvatar {...avatar} />
      <SC.Separator />
      {description && <SC.Description>{description}</SC.Description>}
      {button && <SC.Button {...button} />}
      {(description || button) && <SC.Separator />}
      <SC.AddressWrapper>
        <SC.AddressLabel>{addressLabel}</SC.AddressLabel>
        <SC.Address>{address}</SC.Address>
        {links.seeItinerary && <SC.ItinaryLink {...links.seeItinerary} />}
      </SC.AddressWrapper>
      {links.discoverAds && (
        <>
          <SC.Separator />
          <SC.AdsLink {...links.discoverAds}>
            {links.discoverAds.label} <SC.AdsNumber>{adsNumber}</SC.AdsNumber>{' '}
            <SC.ChevonSvg
              icon={Icons.arrowRight}
              width={16}
              height={13}
              color={theme.colors.pinkButton}
            />
          </SC.AdsLink>
        </>
      )}
    </SC.AdsAuthorCard>
  )
}

export default AdsAuthorCard
